/* Bhairav Tatva v15 — phone menu drawer.
   Replaces Horizon's plain child list (e.g. the gemstone names under "Gemstones") with the same
   card the laptop dropdown uses (thumbnails + Hindi names, from the <template> in snippets/bt-dd.liquid),
   and adds a footer with trust links and contact details. Re-applies itself if Horizon re-renders the header. */
(() => {
  const path = (u) => { try { return new URL(u, location.href).pathname.replace(/\/$/, ''); } catch (e) { return u; } };

  const foot = () => {
    const d = document.createElement('div');
    d.className = 'bt-mfoot';
    d.innerHTML =
      '<ul class="bt-mfoot__links" role="list">' +
        '<li><a href="/pages/authenticity">Authenticity</a></li>' +
        '<li><a href="/pages/how-to-spot-fake-rudraksha">How to spot a fake Rudraksha</a></li>' +
      '</ul>' +
      '<div class="bt-mfoot__talk">' +
        '<p class="bt-mfoot__k">Talk to us</p>' +
        '<a href="mailto:contact@bhairavtatva.com">contact@bhairavtatva.com</a>' +
        '<a href="tel:+918826179995">+91 88261 79995</a>' +
      '</div>' +
      '<p class="bt-mfoot__note">Certificate of Authenticity with every bead and stone · Free shipping across India</p>';
    return d;
  };

  const enhance = () => {
    const nav = document.querySelector('.menu-drawer__navigation');
    if (!nav) return;
    const drawer = nav.closest('.menu-drawer');
    if (drawer) drawer.classList.add('bt-mdrawer');
    document.querySelectorAll('template[data-bt-dd]').forEach((t) => {
      const p = path(t.dataset.btDd);
      nav.querySelectorAll('a.menu-drawer__menu-item--mainlist').forEach((a) => {
        if (path(a.href) !== p) return;
        const li = a.closest('li');
        if (!li || li.querySelector(':scope > .bt-mdd')) return;
        const card = t.content.firstElementChild.cloneNode(true);
        card.className = 'bt-mdd';
        li.classList.add('bt-mdd-host');
        li.append(card);
      });
    });
    if (drawer && !drawer.querySelector(':scope > .bt-mfoot')) drawer.append(foot());
  };

  let queued = false;
  const schedule = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; enhance(); });
  };

  const init = () => {
    enhance();
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
